import React from "react";
import Chart from "chart.js";
import moment from "moment";
import cx from "classnames";

import { getTimeSeries } from "services/statistics/vessel-updater";

import "./styles.scss";

export default class VesselUpdaterPage extends React.Component {

    groups = {
        MarineMap: "marine_traffic/loadMapData",
        MarineShip: "marine_traffic/getShipInfo",
        MarineVesselDetails: "marine_traffic/getVesselDetails",
        
        ShipnextNewVessel: "shipnext/newVesselOnMonitor",
        ShipnextLocationAvailable: "shipnext/notifyLocationAvailable",
        ShipnextNewPosition: "shipnext/notifyNewPosition",
        ShipnextVesselAvailable: "shipnext/notifyVesselAvailable",
        
        
        InternalSaveRoutePoint: "saveRoutePoint",
        InternalScheduleOnRouteUpdates: "scheduleOnRouteUpdates",
        InternalProxyUse: "internal/proxyUse",

        ApiVesselPosition: "api/vesselPosition",
        ApiShipsNearPort: "api/getShipsNearPort",
        ApiShipsDirectingToPort: "api/getShipsDirectingToPort",
        ApiVesselsForceUpdate: "api/scheduleVesselUpdates",
    };
    periods = [
        {
            title: "1s",
            value: "1second",
            fetchCount: 60,
        },
        {
            title: "1m",
            value: "1minute",
        },
        {
            title: "5m",
            value: "5minutes",
        },
        {
            title: "10m",
            value: "10minutes",
        },
        {
            title: "1h",
            value: "1hour",
        },
        {
            title: "1d",
            value: "1day",
        },
    ];
    state = { periodIndex: 0, data: {"saveRoutePoint":[[1594980000,0],[1594983600,0],[1594987200,1]]} }

    get period() {
        return this.periods[this.state.periodIndex];
    }

    componentDidMount() {
        this.loadData(this.period);
    }

    loadData(period) {
        getTimeSeries(Object.values(this.groups), period.value, period.fetchCount || 20).then(data => {
            this.setState(state => ({
                ...state,
                data: {
                    ...state.data,
                    ...data,
                }
            }))
        });
    }

    setPeriod = (periodIndex) => () => {
        this.setState({ periodIndex }, () => {
            this.loadData(this.period);
        });
    }

    renderChart(name) {
        const { data } = this.state;
        return (
            <React.Fragment>
                <p>{ name }</p>
                <BaseChart data={data[name]} period={this.period.value} />
            </React.Fragment>
        );
    }
    
    render() {
        const { periodIndex } = this.state;


        return <div className="container">
            <div className="row">
                <h3 style={{textAlign: "center", width: "100%"}}>Vessel-updater stats</h3>
            </div>
            <div className="row">
                <div className="col-xs-1 col-xs-offset-4" style={{display: "flex", alignItems: "center"}}>
                    Period:
                </div>
                
                <div className="col-xs-3">
                    <PeriodSelector periods={this.periods} selectedIndex={periodIndex} setPeriod={this.setPeriod} />
                </div>
            </div>

            <p>MARINE</p>
            <div className="row">
                <div className="col-xs-12">
                    { this.renderChart(this.groups.MarineShip) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.MarineMap) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.MarineVesselDetails) }
                </div>
            </div>

            <p>API</p>
            <div className="row">
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ApiVesselPosition) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ApiShipsNearPort) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ApiShipsDirectingToPort) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ApiVesselsForceUpdate) }
                </div>
            </div>


            <p>SHIPNEXT</p>
            <div className="row">
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ShipnextNewVessel) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ShipnextLocationAvailable) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ShipnextVesselAvailable) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.ShipnextNewPosition) }
                </div>
            </div>

            <p>INTERNAL</p>
            <div className="row">
                <div className="col-xs-6">
                    { this.renderChart(this.groups.InternalSaveRoutePoint) }
                </div>
                <div className="col-xs-6">
                    { this.renderChart(this.groups.InternalScheduleOnRouteUpdates) }
                </div>
                <div className="col-xs-12">
                    { this.renderChart(this.groups.InternalProxyUse) }
                </div>
            </div>
        </div>
    }
}

function PeriodSelector({ periods, selectedIndex, setPeriod }) {
    return <div className="period-selector">
        {
            periods.map((p, i) => (
                <div key={`period_${i}`} className={cx("period", { "selected": i === selectedIndex })} onClick={setPeriod(i)}>{ p.title }</div>
            ))
        }
    </div>
}

class BaseChart extends React.Component {

    componentDidMount() {
        this.drawChart();
    }

    componentDidUpdate() {
        this.drawChart();
    }

    drawChart() {
        const { data = [], period } = this.props;

        const labels = [];
        const points = [];

        const periodFn = {
            "1second": time => moment.utc(time).get("seconds"),
            "1minute": time => moment.utc(time).get("minutes"),
            "5minutes": time => moment.utc(time).get("minutes"),
            "10minutes": time => moment.utc(time).get("minutes"),
            "1hour": time => moment.utc(time).format("hh"),
            "1day": time => moment.utc(time).format("dd"),
        }[period];


        for (const item of data) {
            labels.push(periodFn(item[0] * 1000));
            points.push(item[1]);
        }

        const datasets = [
            {
                label: "Real",
                backgroundColor: "rgb(135 197 239)",
                borderColor: "rgb(54, 162, 235)",
                data: points,
            },
        ];

        if (!this.chart) {
            this.chart = this.createChart(labels, datasets);
        } else {
            this.chart = this.updateChart(this.chart, labels, datasets);
        }
    }

    updateChart(chart, labels, datasets) {
        chart.clear();
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update();

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chart.getContext("2d");
        const chart = new Chart(ctx, {
            type: "line",
            data: {
                labels,
                datasets,
            },
            fill: true,
            options: {
                tooltips: {
                    mode: "label",
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true,
                    }],
                },
            },
        });

        return chart;
    }

    render() {
        return (
            <canvas ref="chart" />
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/Statistics/vessel-updater/Page.jsx